import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import { DISPLAY_HEADING, EYEBROW } from "../utils/typography";
import { usePageTitle } from "../hooks/usePageTitle";
export function NotFound() {
  usePageTitle("Page not found");
  return <main id="main-content" tabIndex={-1} className="flex min-h-screen w-full flex-col items-start justify-center bg-cream px-6 py-36 md:px-12 lg:px-20" data-id="element-412" data-mp="154pmiixc787i">
      <p className={`${EYEBROW} text-rust`} data-id="element-413" data-mp="1a3ixo4p5in4i">Not found</p>
      <h1 className={`mt-4 max-w-[14ch] ${DISPLAY_HEADING} text-espresso`} data-id="element-414" data-mp="1f2lskwbf3cyr">This page isn’t here.</h1>
      <Link to="/" className="mt-10 inline-flex h-12 items-center gap-2 whitespace-nowrap rounded-full bg-espresso px-6 text-sm font-medium uppercase text-cream transition-colors duration-150 ease-out hover:bg-rust" data-id="element-415" data-mp="1jtc2mmusg3zs">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-416" data-mp="1swd60fs9rgzr" />
        Back home
      </Link>
    </main>;
}